import { useState, useEffect, useCallback } from 'react';
import { videosApi, type GetVideosParams } from '../services/api';
import type { Video } from '../types';

export function useVideos(params?: GetVideosParams) {
  const [videos, setVideos] = useState<Video[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const [total, setTotal] = useState(0);

  const fetchVideos = useCallback(async () => {
    try {
      setLoading(true);
      setError(null);

      const response = await videosApi.getAll(params);

      setVideos(response.videos);
      setTotal(response.total);
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Failed to fetch videos');
    } finally {
      setLoading(false);
    }
  }, [params?.filter, params?.daysBack]);

  const refresh = useCallback(() => {
    fetchVideos();
  }, [fetchVideos]);

  useEffect(() => {
    fetchVideos();
  }, [fetchVideos]);

  return {
    videos,
    loading,
    error,
    total,
    refresh,
  };
}
